module.exports = __webpack_public_path__ + "static/media/brain2.0e7bf880.png";